const mEditionAssetActivation = {
  mEditionAssetActivation: {
    alerts: {
      updateContenidoActivarNodos: {
        error: 'Un error ha ocurrido. Verifica los datos ingresados y vuelve a intentarlo.',
        success: 'Los días de entrega fueron editados exitosamente.'
      }
    },

    buttonPrimary: {
      nodo: 'GUARDAR'
    },

    immediate: {
      disableAll: 'Desactivar todos',
      enableAll: 'Activar todos:'
    },

    messages: {
      activeOne: 'La activación de cada contenido se realizará tomando en cuenta el día de entrega + la fecha de inicio del curso',
      activeZero: 'La activación de cada contenido se realizará tomando en cuenta la fecha de inscripción del alumno + el día de entrega.'
    },

    quote: {
      firstText: 'Aún no tienes contenidos creados en tu curso.',
      secondText: 'Para configurar los días de activación primero debes crear contenidos ingresando a'
    },

    titles: {
      days: 'Configura los días de entrega para tus contenidos'
    }
  }
}

export default mEditionAssetActivation
